<div class="payment-method-cards-wrapper">
  <mat-card class="mollie">
    <form [formGroup]="mollieForm" class="payment-form">
      <div class="header">
        <div class="payment-type">
          <mat-icon [class.enabled]="mollieEnabled()">verified</mat-icon>
          Mollie
        </div>
        <mat-slide-toggle formControlName="mollie_enabled"> Actief </mat-slide-toggle>
      </div>
      <mat-form-field>
        <mat-label>Webadres BVV mijn-omgeving</mat-label>
        <input formControlName="app_url" type="text" matInput required />
        @if (mollieForm.controls.app_url.errors?.required) {
          <mat-error>Vul dit veld in.</mat-error>
        }
      </mat-form-field>
      <p class="supporting-text">
        De "Applicatie-ID" en het "Beveiligingstoken" vind je in onze Mollie-omgeving onder Developers -> Jouw apps.
        Voeg hier een applicatie toe om een nieuwe Buurtvervoerder aan te maken.
      </p>
      <mat-form-field>
        <mat-label>Applicatie ID</mat-label>
        <input formControlName="client_id" type="text" matInput required />
        @if (mollieForm.controls.client_id.errors?.required) {
          <mat-error>Vul dit veld in.</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Beveiligingstoken</mat-label>
        <input formControlName="client_secret" type="text" matInput required />
        @if (mollieForm.controls.client_secret.errors?.required) {
          <mat-error>Vul dit veld in.</mat-error>
        }
      </mat-form-field>
      <p class="supporting-text">
        De "Profile-ID" vind je in de Mollie-omgeving van de klant onder Developers -> API-keys.
      </p>
      <mat-form-field>
        <mat-label>Profile ID</mat-label>
        <input formControlName="profile_id" type="text" matInput required />
        @if (mollieForm.controls.profile_id.errors?.required) {
          <mat-error>Vul dit veld in.</mat-error>
        }
      </mat-form-field>
      <mat-slide-toggle formControlName="prod"> Productie mode </mat-slide-toggle>
      <div class="mollie-coupling">
        <p class="warning-text">
          Let op: nadat je de instellingen hebt opgeslagen, koppel je de Mollie-omgeving van de klant aan onze eigen
          Mollie-omgeving. Log in bij de Mollie-omgeving van de klant en klik daarna op 'Mollie koppelen'.
        </p>
        <button mat-flat-button type="button" (click)="connectMollie()" class="secondary-buttons secondary-color">
          Mollie koppelen
        </button>
      </div>

      <button mat-flat-button (click)="saveMollie()">Mollie instellingen opslaan</button>
    </form>
  </mat-card>
  @if (sepaAllowed()) {
    <mat-card class="sepa">
      <form [formGroup]="sepaForm" class="payment-form">
        <div class="header">
          <div class="payment-type">
            <mat-icon [class.enabled]="sepaEnabled()">verified</mat-icon>
            SEPA
          </div>
          <mat-slide-toggle formControlName="sepa_enabled"> actief </mat-slide-toggle>
        </div>
        <mat-form-field>
          <mat-label>Incassant naam</mat-label>
          <input formControlName="creditor_name" type="text" matInput required />
          @if (sepaForm.controls.creditor_name.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant adres</mat-label>
          <input formControlName="creditor_address" type="text" matInput required />
          @if (sepaForm.controls.creditor_address.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant postcode</mat-label>
          <input formControlName="creditor_postal" type="text" matInput required />
          @if (sepaForm.controls.creditor_postal.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant plaatsnaam</mat-label>
          <input formControlName="creditor_municipality" type="text" matInput required />
          @if (sepaForm.controls.creditor_municipality.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant land</mat-label>
          <input formControlName="creditor_country" type="text" matInput required />
          @if (sepaForm.controls.creditor_country.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant IBAN</mat-label>
          <input formControlName="creditor_iban" type="text" matInput required />
          @if (sepaForm.controls.creditor_iban.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant ID</mat-label>
          <input formControlName="creditor_id" type="text" matInput required />
          @if (sepaForm.controls.creditor_id.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Incassant BIC</mat-label>
          <input formControlName="creditor_bic" type="text" matInput required />
          @if (sepaForm.controls.creditor_bic.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Machtigingskenmerk</mat-label>
          <input formControlName="creditor_mandate_id" type="text" matInput required />
          @if (sepaForm.controls.creditor_mandate_id.errors?.required) {
            <mat-error>Vul dit veld in.</mat-error>
          }
        </mat-form-field>
        <div class="sepa-file-buttons">
          <button mat-flat-button type="button" class="secondary-buttons secondary-color" (click)="downloadSepa()">
            SEPA-formulier Downloaden
          </button>
          @if (isDefaultSepaPath()) {
            <button
              mat-flat-button
              type="button"
              class="secondary-buttons secondary-color"
              (click)="openFileInput('pdf')"
              [disabled]="sepaForm.controls.creditor_mandate_id.value.length === 0"
            >
              SEPA-formulier uploaden
            </button>
          }
          @if (!isDefaultSepaPath()) {
            <div class="sepa-alteration-buttons">
              <button mat-stroked-button class="alter-sepa-button" (click)="openFileInput('pdf')">
                <mat-icon>upload</mat-icon>Wijzig SEPA formulier
              </button>
              <div
                class="delete-sepa-button"
                role="button"
                tabindex="0"
                aria-label="SEPA-formulier verwijderen"
                (click)="deleteSepa()"
                (keydown.enter)="deleteSepa()"
                (keydown.space)="$event.preventDefault(); deleteSepa()"
              >
                Verwijder
              </div>
            </div>
          }
        </div>
        <button mat-flat-button (click)="saveSepa()">SEPA instellingen opslaan</button>
        <input
          class="hidden-input"
          type="file"
          id="pdf"
          (change)="uploadSepa($event)"
          placeholder="Upload file"
          accept=".pdf"
        />
      </form>
    </mat-card>
  }
</div>
